import React from "react"

function Wheel({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <mask
        id="mask0_10_433"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="8"
        y="8"
        width="20"
        height="20"
      >
        <path d="M28 8H8V28H28V8Z" fill="white" />
      </mask>
      <g mask="url(#mask0_10_433)">
        <path
          d="M18 26.3332C22.6024 26.3332 26.3333 22.6022 26.3333 17.9998C26.3333 13.3975 22.6024 9.6665 18 9.6665C13.3976 9.6665 9.66666 13.3975 9.66666 17.9998C9.66666 22.6022 13.3976 26.3332 18 26.3332Z"
          stroke="#003E4C"
          strokeWidth="1"
        />
        <path
          d="M18 23C20.7614 23 23 20.7614 23 18C23 15.2386 20.7614 13 18 13C15.2386 13 13 15.2386 13 18C13 20.7614 15.2386 23 18 23Z"
          stroke="#003E4C"
          strokeWidth="1"
        />
        <path
          d="M18 19.6668C18.9205 19.6668 19.6667 18.9206 19.6667 18.0002C19.6667 17.0797 18.9205 16.3335 18 16.3335C17.0795 16.3335 16.3333 17.0797 16.3333 18.0002C16.3333 18.9206 17.0795 19.6668 18 19.6668Z"
          stroke="#003E4C"
          strokeWidth="1"
        />
        <path
          d="M13 18H16.3333"
          stroke="#003E4C"
          strokeWidth="1"
          strokeLinecap="round"
        />
        <path
          d="M19.6667 18H23"
          stroke="#003E4C"
          strokeWidth="1"
          strokeLinecap="round"
        />
        <path
          d="M15.5 22.3301L17.1667 19.4434"
          stroke="#003E4C"
          strokeWidth="1"
          strokeLinecap="round"
        />
        <path
          d="M18.8333 16.5567L20.5 13.6699"
          stroke="#003E4C"
          strokeWidth="1"
          strokeLinecap="round"
        />
        <path
          d="M20.5 22.3301L18.8333 19.4434"
          stroke="#003E4C"
          strokeWidth="1"
          strokeLinecap="round"
        />
        <path
          d="M17.1667 16.5567L15.5 13.6699"
          stroke="#003E4C"
          strokeWidth="1"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}
export default Wheel
